// extracted by mini-css-extract-plugin
export default {"emptyStub":"MyCoursesList_emptyStub__OAsDL","wrapper":"MyCoursesList_wrapper__8XI-q"};